<template>
  <v-container>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="deleteDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn :loading="deleteLoading" color="error" @click="remove(id)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-dialog v-model="dialog" max-width="1024">
        <v-form ref="form">
          <PatternsSupervisor v-if="remountingSchedule" v-bind:pId="id" v-bind:isEditLabel="isEditLabel" @close="close()" @response="retrieveResponse($event)"></PatternsSupervisor>
        </v-form>
      </v-dialog>

      <v-card flat>
        <v-row class="mb-3">
          <v-col md="6">
            <v-btn color="primary" @click="addSchedule()" :disabled="disableSupervisorPrima()">
              {{$t('add_schedule')}}
            </v-btn>
          </v-col>
          <v-col md="6 pt-0">
            <v-text-field :rules="[validator.alfaNumberNotRequired]" :label="$t('find_schedule')" prepend-inner-icon="mdi-magnify" single-line v-model="search.keyword"></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="loading"></v-skeleton-loader>
      <v-card>
        <v-data-table v-if="!loading" :loading="loading" :headers="checkSupervisor()" :items="listPattern" :search="search.keyword" :no-data-text="$t('no_data')" :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
           <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
          <template v-slot:item.index="{ item }"> {{item.index}} </template>
          <template v-slot:item.days="{ item }"> {{item.shift_days.length}} </template>
          <template v-slot:item.action="{ item }">
            <v-btn icon class="mr-2" color="primary" v-if="!disableSupervisorPrima()" @click="editSchedule(item.id)">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="error" v-if="!disableSupervisorPrima()" @click="deleteConfirmation(item.id)">
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-container>
</template>
<script>
import PatternsSupervisor from './PatternSupervisor'
export default {
  name: "Patterns",
  data() {
    return {
      isEditLabel: false,
      remountingSchedule: true,
      isAdd: false,
      loading: false,
      deleteDialog: false,
      deleteLoading: false,
      dialog: false,
      groupList: [],

      headers: [
        { text: 'No', value: 'index' },
        { text: this.$i18n.t('schedule_name'), value: 'schedule_name' },
        { text: this.$i18n.t('tolerance'), value: 'tolerance' },
        { text: this.$i18n.t('work_days'), value: 'days' },
        { text: this.$i18n.t('action'), value: 'action' },
      ],

      headersSupervisor: [
        { text: 'No', value: 'index' },
        { text: this.$i18n.t('schedule_name'), value: 'schedule_name' },
        { text: this.$i18n.t('tolerance'), value: 'tolerance' },
        { text: this.$i18n.t('work_days'), value: 'days' },
      ],
      search: { keyword:'' },

      id: null,
      validator: this.$store.state.validator,
      baseUrl: this.$store.state.baseUrl,
      companyId: this.$store.state.company,
      role: this.$store.state.role,
      listPattern: [],
    }
  },
  methods: {
    checkSupervisor(){
      if((this.$store.state.company == "prima-hotel" && this.$store.state.role) == 3 || (this.$store.state.company == "prima-hotel" && this.$store.state.role == 4)){
        return this.headersSupervisor
      }else{
        return this.headers
      }
    },
    disableSupervisorPrima(){
      return (this.$store.state.company == "prima-hotel" && this.$store.state.role) == 3 || (this.$store.state.company == "prima-hotel" && this.$store.state.role == 4)
    },
    addSchedule() {
      this.isEditLabel = false
      this.isAdd = true
      this.dialog = true
      this.remountingSchedule = false
      setTimeout(() => {
        this.remountingSchedule = true
      }, 20);
    },
    close() {
      this.dialog = false
    },
    retrieveResponse(event) {
      if (event.type == 'success') {
        this.dialog = false
        this.refresh()
      }
      this.showMessage(event.msg, event.type)
    },
    editSchedule(id) {
      this.isEditLabel = true
      this.isAdd = false
      this.id = id
      this.dialog = true
    },
    deleteConfirmation(id) {
      this.deleteDialog = true
      this.id = id
    },
    async getShiftPattern() {
      this.loading = true
      const result = await this.$store.dispatch('getShiftPatternByCompany', {companyId: this.companyId})
      this.loading = false
      let data = []
      if (result.length > 0) {
        data = this.mappingListPattern(result)
      }
      return data
    },
    async getGroup() {
      this.loading = true
      const result = await this.$store.dispatch('getGroupByCompany', {companyId: this.companyId})
      this.loading = false
      let data = []
      if (result.length > 0) {
        data = result
      }
      return data
    },
    async remove(id) {
      this.deleteLoading = true
      const result = await this.$store.dispatch('deleteSchedulePattern', {id})
      this.deleteLoading = false
      if (result) {
        this.deleteDialog = false
        this.showMessage(this.$i18n.t('alert_delete'), 'success')
        this.refresh()
      }
    },
    mappingListPattern(result) {
      let data = []
      result.map((item,i) => {
        data.push({index:i+1, ...item})
      })

      return data
    },

    showMessage(msg, type) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    async refresh() {
      this.listPattern = await this.getShiftPattern()
    }
  },
  async created() {
    this.listPattern = await this.getShiftPattern()
    if (this.role != 3) {
      this.groupList = await this.getGroup()
    }
  },
  watch: {
    dialog(show) {
      if(this.isAdd && show) this.id = null
    }
  },
  components: {
    PatternsSupervisor
  }
}
</script>
